import _ from "lodash";
import { QUEUE_STATUS } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        queueStatus: _.cloneDeep(constants.QUEUE_STATUS_INPUT)
    }
}

const queueStatusReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case QUEUE_STATUS.SET_QUEUE_STATUS_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case QUEUE_STATUS.SET_QUEUE_STATUS:
        case QUEUE_STATUS.SET_QUEUE_STATUS_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    queueStatus: action.queueStatus
                }
            })
        default:
            return state
    }
}

export default queueStatusReducer